const fecha_actual = state => state.fecha_actual;

export default {
  fecha_actual,
};